// Roles only. Shared table methods are in tableMixin.js.
// Methods here with the same name as a tableMixin method replace it on this page.
import axios from "axios";

export default {
    name: "Roles",
    methods: {
        clearForm() {
            this.isEditing = false;
            this.isSaving = false;
            this.submitted = false;
            this.formInputs.id = "";
            this.formInputs.role = "";
            this.formInputs.permissions = [];
            this.$clearValidationStates("#recordForm");
        },
        handleFetchPermissionsSuccess(response) {
            this.permissionOptions = response.data.results;
        },
        // Delete one role: explains why a role can't be deleted
        deleteRecord(id) {
            this.$showOrHideLoader(this.tableData.loaderMessage);
            const data = { id, deleteType: this.tableData.deleteType, action: "deleteRecord" };

            axios
                .delete(this.apiUrl, this.$handleConfig(data))
                .then((response) => {
                    if (response.data.status == "success") {
                        this.handleDeleteRecordSuccess(response);
                    } else {
                        this.tableData.isVisible = false;
                        this.handleError("ending", "This role could not be deleted. It may be a system role, or some users still have it. Change those users' role first.", "danger", "page");
                    }
                })
                .catch((error) => this.handleRequestError(error, "page"));
        },
    },
};